import React, { useState } from "react";

import { Router, Redirect } from "@reach/router";
import { connect } from "react-redux";

import Home from "./screens/Home";
import Questionnaire from "./screens/Questionnaire";
import CookiePolicy from "./screens/CookiePolicy";

import { setUserProfile } from "./state/actions/user";
import CookieBot from "./components/CookieBot/CookieBot";
import { useMount } from "react-use";
import { Auth } from "aws-amplify";
import { normalizeUser } from "./utils/normalizeUser";
import { RTL_LANGUAGES } from "./constants";
import { getSelectedLocale } from "./state/selectors/i18n";
import { useEffect } from "react";
import { useMemo } from "react";
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";

const App = ({ setUserProfile, locale }) => {
  const [authInit, setAuthInit] = useState(false);

  useMount(async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();

      if (user) setUserProfile(normalizeUser(user));
    } catch (e) {
      console.log(e);
    }

    setAuthInit(true);
  });

  const isRtl = useMemo(() => {
    return RTL_LANGUAGES.includes(locale);
  }, [locale]);

  const jss = useMemo(() => {
    const plugins = [...jssPreset().plugins];

    if (isRtl) plugins.push(rtl());

    return create({
      plugins,
    });
  }, [isRtl]);

  useEffect(() => {
    document.dir = isRtl ? "rtl" : "ltr";
  }, [isRtl]);

  return (
    <>
      <CookieBot />

      {authInit ? (
        <StylesProvider jss={jss}>
          <Router style={{ height: "100%" }}>
            <Redirect from="*" to="/" noThrow />
            <Questionnaire path="/name/:surveyName/branch/:slug" />
            <CookiePolicy path="/cookie-policy" />
            <Home path="/" />
          </Router>
        </StylesProvider>
      ) : (
        <>Loading...</>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  locale: getSelectedLocale(state),
});

const mapDispatchToProps = (dispatch) => ({
  setUserProfile: (user) => dispatch(setUserProfile(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);